import React from 'react';
import './layout/allLayouts';
import { findIndex } from 'underscore';
class UserBlock extends React.Component {
    constructor(props) {
      super(props);
      this.displayName = 'UserBlock';
      this.showAllPosts = this.showAllPosts.bind(this);
    }
    showAllPosts(post, index) {
      this.ComponentName = ReactiveTemplates['doPostStandard'];
      return <this.ComponentName post={post} key={'userBlock-' + index} />;
    }
    render() {
      const posts = this.props.previewOption ? this.props.previewOption.data : [];
      return (
        <div className="flex-row">
          { posts.length ? posts.map(this.showAllPosts) : null }
        </div>
      );
    }
}

UserBlock.propTypes = {
  'helperData': React.PropTypes.object,
  'previewOption': React.PropTypes.object,
  'allLayout': React.PropTypes.array,
  'helperData.posts': React.PropTypes.object,
  'helperData.posts.data': React.PropTypes.array,
};


export default UserBlock;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/userBlock.js